import {catch403, postRequest} from "@pg-mono/request";
import {apiLink} from "@pg-mono/rp-api-routes";

import {notifyBugsnag} from "../../errors/bugsnag/notify_bugsnag";
import {ContractorApplicationFormValuesType} from "../components/ContractorApplication";

export const postContractorApplication = (data: ContractorApplicationFormValuesType) => {
    return postRequest({}, apiLink.contact.contractor(), data).catch(
        catch403(async (err) => {
            notifyBugsnag(err, "postContractorApplication: catch 403", err.responseError ?? {});
        })
    );
};
import {catch403, postRequest} from "@pg-mono/request";
import {apiLink} from "@pg-mono/rp-api-routes";

import {notifyBugsnag} from "../../errors/bugsnag/notify_bugsnag";
import {ContractorApplicationFormValuesType} from "../components/ContractorApplication";

export const postContractorApplication = (data: ContractorApplicationFormValuesType) => {
    return postRequest({}, apiLink.contact.contractor(), data).catch(
        catch403(async (err) => {
            notifyBugsnag(err, "postContractorApplication: catch 403", err.responseError ?? {});
        })
    );
};
